import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mv_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response?.status === 401) {
      // Token invalid — clear it. Redirect handled by ProtectedRoute.
      clearToken();
    }
    return Promise.reject(error);
  },
);

export const formatApiError = (error) => {
  const detail = error?.response?.data?.detail;
  if (!detail) return error?.message || "Er is een onbekende fout opgetreden.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
};

// Build a public asset URL from a media object or a relative path
export const mediaUrl = (mediaOrPath) => {
  if (!mediaOrPath) return null;
  if (typeof mediaOrPath === "string") {
    if (mediaOrPath.startsWith("http")) return mediaOrPath;
    return `${BACKEND_URL}${mediaOrPath}`;
  }
  if (mediaOrPath.url) {
    return mediaOrPath.url.startsWith("http")
      ? mediaOrPath.url
      : `${BACKEND_URL}${mediaOrPath.url}`;
  }
  return null;
};

export default apiClient;
